import { NavLink } from "react-router-dom";
import styled from "styled-components";

// TODO: Add as resuable component?
export const CustomNavLink = styled(NavLink)`
  color: inherit;
  text-decoration: none;
`;
